<template>
  <div>
    <!-- 新增按钮 -->
 
    <DatePicker
      v-model="searchDate"
      type="daterange"
      placement="bottom-end"
      placeholder="选择时间"
      style="width: 200px"
      :options="options3"
    ></DatePicker>
    <Button type="primary" @click="resetFormData">清除</Button>

    <Button type="primary" @click="queryGoods">查询</Button>

    <Table :columns="columns10" :data="data9"> </Table>
 
    <Modal v-model="modal1" title="封号" width="300">
      <div>
        <Input
          v-if="isfengjin"
          v-model="beizhu"
          placeholder="请输入封号备注"
          style="width: 200px"
        />
        <div v-if="isfengjin == false">确定解封该用户?</div>
      </div>
      <div slot="footer">
        <Button @click="submitJiefeng" v-if="isfengjin == false"
          >确认解封</Button
        >
        <Button @click="submitFenghao" v-if="isfengjin">确认封号</Button>
        <Button @click="cancelFenghao">取消</Button>
      </div>
    </Modal>
    <Modal v-model="modal2" title="充值" width="400">
      <div>
        <RadioGroup v-model="rechargeType">
          <Radio label="充值">充值</Radio>
          <Radio label="扣除">扣除</Radio>
        </RadioGroup>

        <Select
          v-model="currencyType"
          placeholder="选择能量或金币"
          style="width: 200px; margin-top: 10px"
        >
          <Option value="能量">能量</Option>
          <Option value="金币">金币</Option>
        </Select>

        <Input
          v-model="amount"
          placeholder="输入币数或能量数"
          style="width: 200px; margin-top: 10px"
        />

        <p style="margin-top: 10px" v-if="currencyType == '能量'">
          操作后能量:
          {{
            rechargeType == "充值"
              ? parseInt(amount) + parseInt(selUser.integral)
              : parseInt(selUser.integral) - parseInt(amount)
          }}
        </p>
        <p style="margin-top: 10px" v-if="currencyType == '金币'">
          操作后余额:
          {{
            rechargeType == "充值"
              ? parseInt(amount) + parseInt(selUser.balance)
              : parseInt(selUser.balance) - parseInt(amount)
          }}
        </p>
        <Input
          v-model="reasontxt"
          placeholder="输入理由"
          style="width: 200px; margin-top: 10px"
        />
      </div>

      <div slot="footer">
        <Button @click="submitRecharge">确认</Button>
        <Button @click="cancelRecharge">取消</Button>
      </div>
    </Modal>
    <userDetailModal
      :visible="modal3"
      :user_id="clickuserid"
      @guanbimodal="guanbimodal"
    />
    <userInfoModal
      :visible="modal4"
      :user_id="clickuserid"
      @guanbimodal="guanbimodal"
    />
  </div>
</template>

<script>
import { cmsUserList, cmsUserBanned,cmsRechangeRank } from "../../api/user";
import { cmsMoneyApplyadd } from "../../api/moneyApply";
import userDetailModal from "./userDetailModal.vue"; // 引入刚刚创建的封号组件
import userInfoModal from "./userInfoModal.vue";
import { formatOssUrl } from "@/utils";

export default {
  components: { userDetailModal, userInfoModal },
  data() {
    return {
      selUser: {},
      modal4: false,
      modal3: false,
      modal2: false, // 控制充值弹窗的显示与否
      rechargeType: "充值", // 充值或扣除的类型，"recharge"表示充值，"deduct"表示扣除
      currencyType: "金币", // 选择的类型，可以是"points"或"coins"
      reasontxt: "",
      amount: 0, // 输入的金额或者能量
      isfengjin: false,
      modal1: false,
      searchDate: [],
      loading: false,
      beizhu: "",
      clickuserid: "",
      data9: [], // 用于存储查询结果
      options3: {
        disabledDate(date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 将时间设置为当天的开始
          return date && date.getTime() > today.getTime() - 1;
        },
      },
      columns10: [
        {
          title: "用户id",
          key: "user_id",
        },
        {
          title: "用户昵称",
          key: "user_nickname",
        },
        {
          title: "真实姓名",
          key: "idname",
        },
        {
          title: "头像",

          key: "head_photo",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: formatOssUrl(params.row.head_photo) ,
              },
              style: {
                width: "50px",
                height: "50px",
                marginTop: "5px",
              },
            });
          },

          // key: "image",
        },
        {
          title: "等级",
          key: "user_level",
        },
        {
          title: "余额",
          key: "balance",
        },
        {
          title: "能量",
          key: "integral",
        },
        {
          title: "注册时间",
          key: "register_time",
        },
        {
          title: "充值金额",
          key: "total_paymoney",
        },
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "center",
          render: (h, params) => {
            return h("div", [
            
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.clickuserid = params.row.user_id.toString();
                      this.modal4 = true;
                    },
                  },
                },
                "用户信息"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.clickuserid = params.row.user_id.toString();
                      console.log("====" + this.clickuserid);
                      this.modal3 = true;
                    },
                  },
                },
                "详情"
              ),
              
            ]);
          },
        },
      ],
      searchId: "",
      searchName: "",
      searchPhone: "",
      current: 1,
      total: 0,
    };
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    submitFenghao() {
      cmsUserBanned({
        user_id: this.clickuserid,
        bannedtxt: this.beizhu,
        user_status: 1,
      })
        .then((response) => {
          this.modal1 = false;
          this.queryGoods(); // 直接调用查询函数，不用重复逻辑
        })
        .catch((error) => {
          console.error(error);
        });
    },
    submitJiefeng() {
      cmsUserBanned({
        user_id: this.clickuserid,
        bannedtxt: "",
        user_status: 0,
      })
        .then((response) => {
          this.modal1 = false;
          this.queryGoods(); // 直接调用查询函数，不用重复逻辑
        })
        .catch((error) => {
          console.error(error);
        });
    },
    guanbimodal() {
      this.modal3 = false;
      this.modal4 = false;
    },
    cancelFenghao() {
      this.modal1 = false;
    },
    // 查询商品
    // 公共查询函数
    fetchGoodsData () {
      var starttime = "";
      var endtime = "";
      if (this.searchDate.length > 0 && this.searchDate[0] != "") {
        starttime = this.formatDate(this.searchDate[0]);
        endtime = this.formatDate(this.searchDate[1]);
      }
      const params = {
        starttime,
        endtime,
      };
      cmsRechangeRank(params)
        .then((response) => {
          this.data9 = response.data; // 获取查询结果
         
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // 查询商品
    queryGoods() {
    
      this.fetchGoodsData();
    },
    // 格式化函数，将 Date 对象转换为 YYYY-MM-DD HH:mm:ss 格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    // 分页查询
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },

    resetFormData() {
      // 重置表单数据
      this.searchId = "";
      this.searchName = "";
      this.searchPhone = "";
      this.searchDate = [];
      this.current = 1;
      this.queryGoods();
    },
    submitRecharge() {
      // 提交充值或扣除操作的逻辑
      const actionType = this.rechargeType === "充值" ? 0 : 1;
      const currency = this.currencyType === "金币" ? 0 : 1;
      if (this.amount <= 0) {
        this.$Message.error("充值或扣除金额必须大于0");
        return;
      }
      if (
        this.rechargeType === "扣除" &&
        this.currencyType === "金币" &&
        this.amount > this.selUser.balace
      ) {
        this.$Message.error("扣除金额不能大于余额");
        return;
      }

      if (
        this.rechargeType === "扣除" &&
        this.currencyType === "能量" &&
        this.amount > this.selUser.integral
      ) {
        this.$Message.error("扣除能量不能大于余额");
        return;
      }

      // 这里可以调用 API 提交数据
      cmsMoneyApplyadd({
        user_id: this.selUser.user_id,
        applycoin: this.amount,
        applytype: currency,
        applystatus: actionType,
        user_name: this.selUser.user_nickname,
        reasontxt: this.reasontxt,
      })
        .then((response) => {
          this.$Message.success(`申请成功,等待审核`);
          this.modal2 = false;
        })
        .catch((error) => {
          this.$Message.error(`${actionType} ${currency} 失败`);
        });
    },

    cancelRecharge() {
      this.modal2 = false; // 关闭弹窗
    },
  },
};
</script>
